module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_6000.972a3560.png";